var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspectorPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_24_1",
    "data-name": "Component 24 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.226,
    height: 23.578,
    viewBox: "0 0 17.226 23.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9177",
    "data-name": "Path 9177",
    d: "M5,0a5.268,5.268,0,0,1,5,5.5A5.268,5.268,0,0,1,5,11,5.268,5.268,0,0,1,0,5.5,5.268,5.268,0,0,1,5,0Z",
    transform: "translate(3.499 3)",
    fill: "#fdb713"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9166",
    "data-name": "Path 9166",
    d: "M32.747,8.574a4.306,4.306,0,1,1-4.306-4.287,4.3,4.3,0,0,1,4.306,4.287m4.468,0a8.613,8.613,0,1,0-15.24,5.476l6.634,9.528,6.731-9.667A8.473,8.473,0,0,0,36,12.958l.068-.1H36.06a8.506,8.506,0,0,0,1.155-4.287",
    transform: "translate(-19.989)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectorPinIcon);
export default __webpack_public_path__ + "static/media/inspector-pin-icon.a805479d560fc58b5b6485707cbc7834.svg";
export { ForwardRef as ReactComponent };